import type { IMonitor } from '@paragon/monitoring';

let configuredMonitor: IMonitor | null = null;

/** Clients that want dialog-button usage metrics call this at startup; others get a no-op. */
export function setMonitorForPopupState(monitor: IMonitor) {
  configuredMonitor = monitor;
}

export function getPopupStateMonitor() {
  return configuredMonitor;
}
